/**
=========================================================
* Trust Cargo - native dropdowns
=========================================================

* A TextField with SelectProps={{ native: true }} is drawn by MUI's
* NativeSelect, which the theme never covered: its arrow was missing, so the
* box read as a plain text field. Same arrow and spacing as every other
* dropdown (select.js), and the pointer, so the whole box reads as one.
*/

import colors from "assets/theme/base/colors";

import pxToRem from "assets/theme/functions/pxToRem";

const { dark } = colors;

const nativeSelect = {
  styleOverrides: {
    select: {
      padding: `0 ${pxToRem(24)} 0 0 !important`,
      cursor: "pointer",
    },

    icon: {
      display: "block",
      color: dark.main,
      right: pxToRem(8),
    },
  },
};

export default nativeSelect;
